var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "swyvNT_4Qh4gc9QTbyrCNKLI0a_0aIgA"
};